import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'

import MessengersPage from '@/pages/Settings/messengers.vue'
import NewsfeedPage from '@/pages/Settings/newsfeed.vue'
import {RouteConfig} from 'vue-router'

// @ts-ignore
import messages from '@/lang/index';

const settings: RouteConfig = {
  path: '/settings',
  name: 'settings',
  meta: {
    pageName: messages.settings.settings
  },
  component: DashboardLayout,
  redirect: '/settings/messengers',
  children: [
    {
      path: 'messengers',
      name: 'messengersPage',
      meta: {
        pageName: messages.settings.messengers_settings
      },
      component: MessengersPage
    },
    {
      path: 'news',
      name: 'newsPage',
      meta: {
        pageName: messages.settings.news_settings
      },
      component: NewsfeedPage
    }
  ]
}

export default settings